import React, { Component } from 'react';
// import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import SVG from '../../images/no-data.svg';
import './ErrorBoundary.scss';
import BaseButton from '../../_ui/BaseButton/BaseButton';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
    this.refreshPage = this.refreshPage.bind(this);
  }

  refreshPage() {
    window.location.reload();
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: error,
      errorInfo,
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="container error-container">
          <div className="flex justify-center error-row">
            <div className="col align-self-center text-center">
              <div className="flex error-row">
                <div className="basis-1/2 error-first-section md:basis-full">
                  <p>
                    <h1>No data :(</h1>
                  </p>
                  <p>
                    <h3>Something went wrong. Caught by error boundary.</h3>
                  </p>
                  <div className="flex justify-center">
                    <BaseButton
                      className="button-primary"
                      onClick={this.refreshPage}
                    >
                      Reload page
                    </BaseButton>
                  </div>
                </div>
                <div className="basis-1/2 md:basis-full">
                  <img src={SVG} alt="error" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element,
};

export default ErrorBoundary;
